import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Overline } from "@/components/Reveal";
import { COMPANY } from "@/data/content";

const CONTENT = {
  mentions: {
    title: "Mentions légales",
    sections: [
      { h: "Éditeur du site", p: `Le présent site est édité par ${COMPANY.name}, dont le siège est situé ${COMPANY.addressFull}. Téléphone : ${COMPANY.phone}. Email : ${COMPANY.email}.` },
      { h: "Directeur de la publication", p: `Le directeur de la publication est le représentant légal de ${COMPANY.name}.` },
      { h: "Hébergement", p: "Le site est hébergé par un prestataire d'hébergement professionnel garantissant la disponibilité et la sécurité des données." },
      { h: "Propriété intellectuelle", p: `L'ensemble des contenus (textes, images, logos, éléments graphiques) présents sur ce site sont la propriété de ${COMPANY.name} et sont protégés par le droit de la propriété intellectuelle. Toute reproduction est interdite sans autorisation préalable.` },
      { h: "Responsabilité", p: "Les informations diffusées sur ce site sont fournies à titre indicatif. Les estimations d'économies et d'aides CEE ne constituent pas un engagement contractuel et dépendent d'un audit précis." },
    ],
  },
  confidentialite: {
    title: "Politique de confidentialité",
    sections: [
      { h: "Collecte des données", p: `Les données personnelles collectées via nos formulaires (nom, société, téléphone, email, informations sur votre bâtiment) sont utilisées uniquement pour traiter votre demande de contact ou d'audit énergétique.` },
      { h: "Finalité du traitement", p: "Vos données servent exclusivement à vous recontacter, à établir un diagnostic et à vous proposer un accompagnement adapté. Elles ne sont ni vendues ni cédées à des tiers à des fins commerciales." },
      { h: "Conservation", p: "Les données sont conservées pendant la durée nécessaire au traitement de votre demande et à la relation commerciale, conformément aux obligations légales." },
      { h: "Vos droits (RGPD)", p: `Conformément au Règlement Général sur la Protection des Données, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition sur vos données. Pour l'exercer, contactez-nous à ${COMPANY.email}.` },
      { h: "Cookies", p: "Ce site peut utiliser des cookies techniques nécessaires à son bon fonctionnement. Aucun cookie publicitaire n'est déposé sans votre consentement." },
    ],
  },
};

export default function Legal({ type }) {
  const data = CONTENT[type] || CONTENT.mentions;
  useEffect(() => {
    document.title = `${data.title} · PRIMEC2E`;
  }, [data.title]);

  return (
    <div className="bg-white">
      <Header />
      <main>
        <section className="bg-[#F4F8EC] border-b border-slate-200 pt-40 pb-16">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10">
            <Overline>Informations légales</Overline>
            <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-midnight">{data.title}</h1>
          </div>
        </section>
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 space-y-10">
            {data.sections.map((s) => (
              <div key={s.h}>
                <h2 className="font-display text-xl font-bold text-midnight">{s.h}</h2>
                <p className="mt-3 text-slate-600 font-light leading-relaxed">{s.p}</p>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
